var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "hkl-attachment" },
    [
      _vm.hasWidths
        ? _c(
            "colgroup",
            [
              _vm.showIndex ? _c("col") : _vm._e(),
              _vm._v(" "),
              _c("col"),
              _vm._v(" "),
              _vm._l(_vm.renderColumns, function (col, index) {
                return _c(
                  "col",
                  _vm._b(
                    { key: index },
                    "col",
                    col.width ? { width: col.width } : {},
                    false
                  )
                )
              }),
              _vm._v(" "),
              _vm.hasDelete ? _c("col", { attrs: { width: "32" } }) : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasHeader
        ? _c("thead", { staticClass: "hkl-attachment_header-group" }, [
            _c(
              "tr",
              { staticClass: "hkl-attachment_header-before" },
              [_vm._t("header-before")],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "hkl-attachment_header" },
              [
                _vm.showIndex ? _c("th", [_vm._v("#")]) : _vm._e(),
                _vm._v(" "),
                _c("th"),
                _vm._v(" "),
                _vm._l(_vm.renderColumns, function (col, index) {
                  return _c(
                    "th",
                    {
                      key: index,
                      class: _vm.kebabCase(col.dataIndex),
                      style: col.widthStyle,
                    },
                    [col.title ? [_vm._v(_vm._s(col.title))] : _vm._e()],
                    2
                  )
                }),
                _vm._v(" "),
                _vm.hasDelete ? _c("th", { attrs: { width: "32" } }) : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "hkl-attachment_header-after" },
              [_vm._t("header-after")],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.fileList, function (file, index) {
        return _c(
          "tbody",
          { key: file.id, staticClass: "hkl-attachment_row-group" },
          [
            _c("tr", { staticClass: "hkl-attachment_row-before" }, [
              _c(
                "td",
                { attrs: { colspan: _vm.mergedColumnsWidth } },
                [
                  _vm._t("row-before", null, {
                    metaData: file.metaData,
                    file: file,
                    index: index,
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.hasDelete ? _c("td") : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "hkl-attachment_row" },
              [
                _vm.showIndex
                  ? _c("td", [
                      _vm._v("\n        " + _vm._s(index + 1) + "\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "div",
                      { staticClass: "hkl-attachment_filename" },
                      [
                        file.canDownload
                          ? _c("HKLDownloadLink", { attrs: { doc: file } })
                          : [_vm._v(_vm._s(file.filename))],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("HKLDescriptionPencilInput", {
                      attrs: { value: file.description, canEdit: file.canEdit },
                      on: {
                        close: function (content) {
                          return _vm.updateDescriptionFn(file.id, content)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._t("file-after", null, {
                      metaData: file.metaData,
                      file: file,
                      index: index,
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.renderColumns, function (col, index) {
                  return [
                    col && col.component
                      ? _c(
                          "td",
                          {
                            key: index,
                            class: [_vm.kebabCase(col.dataIndex), col.class],
                            style: col.widthStyle,
                            attrs: { align: "center" },
                          },
                          [
                            !["a", "span", "p", "div"].includes(
                              col.componentFn(
                                file.metaData[col.dataIndex],
                                index,
                                file
                              )
                            )
                              ? _c(
                                  col.componentFn(
                                    file.metaData[col.dataIndex],
                                    index,
                                    file
                                  ),
                                  _vm._g(
                                    _vm._b(
                                      {
                                        directives: [
                                          {
                                            name: "fusioninputcheck",
                                            rawName: "v-fusioninputcheck",
                                            value: col.fusioninputcheckFn(
                                              file.metaData[col.dataIndex],
                                              index,
                                              file
                                            ),
                                            expression:
                                              "col.fusioninputcheckFn(file.metaData[col.dataIndex], index, file)",
                                          },
                                        ],
                                        tag: "component",
                                        model: {
                                          value: file.metaData[col.dataIndex],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              file.metaData,
                                              col.dataIndex,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "file.metaData[col.dataIndex]",
                                        },
                                      },
                                      "component",
                                      col.attrsFn(
                                        file.metaData[col.dataIndex],
                                        index,
                                        file
                                      ) || {},
                                      false
                                    ),
                                    col.listenersFn(
                                      file.metaData[col.dataIndex],
                                      index,
                                      file
                                    ) || {}
                                  )
                                )
                              : _c(
                                  col.componentFn(
                                    file.metaData[col.dataIndex],
                                    index,
                                    file
                                  ),
                                  _vm._g(
                                    _vm._b(
                                      { tag: "component" },
                                      "component",
                                      col.attrsFn(
                                        file.metaData[col.dataIndex],
                                        index,
                                        file
                                      ) || {},
                                      false
                                    ),
                                    col.listenersFn(
                                      file.metaData[col.dataIndex],
                                      index,
                                      file
                                    ) || {}
                                  ),
                                  [_vm._v(_vm._s(file.metaData[col.dataIndex]))]
                                ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
                _vm._v(" "),
                _vm.hasDelete
                  ? _c(
                      "td",
                      { attrs: { align: "center", width: "32" } },
                      [
                        file.canDelete
                          ? _c("HKLDeleteIcon", {
                              staticClass: "file-upload-delete",
                              on: {
                                click: function () {
                                  return _vm.deleteFile(file)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }